"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.answer = void 0;
exports.answer = {
    yes: "Yes",
    no: "No",
    other: "Other",
    otherExplain: "Other (please explain)",
};
